<template>
  <div>
    <SettingPanel v-if='hasSettings' :title='$t("general")'>
      <div class='mr-6 text-body-2'>
        {{ $t('you_may_let_users_to_send_you_requests', { domain }) }}
      </div>
      <v-switch
        v-model='enableRegister'
        @update:model-value='updateSettings'
        class='mr-0'
        :loading='enableRegisterLoading'
        :disabled='enableRegisterLoading'
        inset
      ></v-switch>
    </SettingPanel>
  </div>
</template>

<script>
  import SettingPanel from '../../panels/settings/Base'
  import { isArr, hasProp } from '../../../utils';

  export default {
    name: 'Settings',
    components: {
      SettingPanel
    },
    data() {
      return {
        enableRegisterLoading: false,
        enableRegister: false,
        hasSettings: false,
        settings: [],
      }
    },
    computed: {
      enabledCommunication: {
        get() {
          return this.user.enabled_communication;
        },
        set(val) {
          console.log(val);
        }
      },
      canAcceptBusinessContactJoin() {
        return this.$ability.can('accept-business-contact-join', 'user');
      },
      user() {
        return this.$store.getters['auth/user'];
      },
      domain() {
        const { email = '' } = this.user;
        const matches = email.match(/@.+/);

        return isArr(matches) ? matches[0] : '';
      },
    },
    created() {
      if (this.canAcceptBusinessContactJoin) {
        this.getSettings();
      }
    },
    methods: {
      getSettings() {
        this.enableRegisterLoading = true;

        return this.$store
          .dispatch('businessUsers/getSettings')
          .then((settings) => {
            this.unwrapSettings(settings);

            if (hasProp(settings, 'enable_register')) {
              this.enableRegister = !!settings.enable_register;
            }

            return settings;
          })
          .finally(() => {
            this.hasSettings = this.settings.length > 0;
            this.enableRegisterLoading = false;
          });
      },
      unwrapSettings(settings) {
        this.settings = Object.entries(settings).map(([k, v]) => ({ [k]: v }));
      },
      updateSettings(val) {
        this.enableRegisterLoading = true;

        const query = {
          settings: {
            enable_register: val ? 1 : 0
          },
        };

        return this.$store
          .dispatch('businessUsers/updateSettings', query)
          .then((settings) => {
            this.unwrapSettings(settings);
            if (hasProp(settings, 'enable_register')) {
              this.enableRegister = !!settings.enable_register;
            }
            return settings;
          })
          .finally(() => {
            this.enableRegisterLoading = false;
          });
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
